/**
 * @generated SignedSource<<823740b837a29b2cef6134c1e8a3199b>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type moreButton_softwareReleasesVersionDetailIssueList_jiraIssue$data = {
  readonly " $fragmentSpreads": FragmentRefs<"ui_softwareReleasesMoveIssuesBetweenVersions_MoveIssuesBetweenVersions_jiraIssue">;
  readonly " $fragmentType": "moreButton_softwareReleasesVersionDetailIssueList_jiraIssue";
};
export type moreButton_softwareReleasesVersionDetailIssueList_jiraIssue$key = {
  readonly " $data"?: moreButton_softwareReleasesVersionDetailIssueList_jiraIssue$data;
  readonly " $fragmentSpreads": FragmentRefs<"moreButton_softwareReleasesVersionDetailIssueList_jiraIssue">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "moreButton_softwareReleasesVersionDetailIssueList_jiraIssue",
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "ui_softwareReleasesMoveIssuesBetweenVersions_MoveIssuesBetweenVersions_jiraIssue"
    }
  ],
  "type": "JiraIssue"
};

(node as any).hash = "fae4c5ea4895f8ef68f1e0800962eb5d";

export default node;
